import { Link, useLocation } from "react-router-dom";
import PageHeader from "./PageHeader";
import { useAdminLang } from "./i18n";

export default function AdminNotFound() {
  const location = useLocation();
  const { t } = useAdminLang();

  return (
    <>
      <PageHeader title="صفحه پیدا نشد" />
      <div className="row justify-content-center">
        <div className="col-xl-6">
          <div className="card custom-card">
            <div className="card-body text-center py-5">
              <span className="avatar avatar-xl avatar-rounded bg-primary-transparent mb-3">
                <i className="ri-error-warning-line fs-24"></i>
              </span>
              <h5 className="fw-medium mb-2">{t("این صفحه در پنل مدیریت وجود ندارد")}</h5>
              <p className="text-muted mb-4">
                <code dir="ltr">{location.pathname}</code>
              </p>
              <Link to="/admin" className="btn btn-primary">{t("بازگشت به داشبورد")}</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
